export default __webpack_public_path__ + "static/media/logo-us-lacoste.ef811490.svg";